import React from 'react';
import styled, { css } from 'styled-components';
import Box from '../Box';

import { colors } from '../../lib/styles';

interface Props {
    image: React.ReactNode;
    attribution?: React.ReactNode;
    scale?: number;
    offset?: [number, number];
    borderWidth?: number;
}

const attributionHeight = '30px';

const StyledImageBorderedBox = styled.div<{
    borderWidth: number;
}>(({ borderWidth }) => {
    return css`
        position: relative;
        width: 100%;
        height: 0;
        padding-bottom: 100%;
        margin-bottom: ${attributionHeight};

        &:before {
            content: '';
            position: absolute;
            z-index: 2;
            display: block;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            border: ${borderWidth}px solid ${colors.grey300};
        }
    `;
});

const ImageWrapper = styled.div<{ scale: number; offset?: [number, number] }>(
    ({ scale, offset }) => {
        const size = 100 * scale;
        let topOffset = ((size - 100) / 2) * -1;
        let leftOffset = ((size - 100) / 2) * -1;

        if (offset) {
            leftOffset = offset[0];
            topOffset = offset[1];
        }

        return css`
            position: absolute;
            z-index: 3;
            top: ${topOffset}%;
            left: ${leftOffset}%;
            display: flex;
            justify-content: center;
            align-items: center;
            width: ${size}%;
            height: ${size}%;

            img {
                position: relative;
                max-width: 100%;
                max-height: 100%;
            }
        `;
    }
);

const AttributionWrapper = styled.div`
    position: absolute;
    top: 100%;
    right: 0;
    height: ${attributionHeight};
    line-height: ${attributionHeight};
    z-index: 1;
    text-align: right;
`;

function ImageBorderedBox({ image, attribution, scale = 1, offset, borderWidth = 10 }: Props) {
    return (
        <StyledImageBorderedBox borderWidth={borderWidth}>
            <ImageWrapper scale={scale} offset={offset}>
                {image}
            </ImageWrapper>
            {attribution && <AttributionWrapper>{attribution}</AttributionWrapper>}
        </StyledImageBorderedBox>
    );
}

export default ImageBorderedBox;
